import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "document-wrapper flex-between"
}
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  class: "flex-center",
  style: {"width":"2.25rem","height":"2.25rem","background-color":"var(--ch-white)","border-radius":"6px"}
}
const _hoisted_4 = { style: {"margin-left":"0.875rem"} }
const _hoisted_5 = {
  key: 0,
  class: "info-note"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  style: {"color":"var(--ch-black-80)","font-size":"var(--font-sm)"}
}

import { PdfFileIcon } from "@/components/svg";

import { formatDate } from '@/lib/utils';
import { IPractitioner } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'StaffDocumentPreview',
  props: {
    staff: {}
  },
  emits: ['view'],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (__props.staff?.practitionerLicenseURL)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(PdfFileIcon))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[2] || (_cache[2] = _createElementVNode("h4", { style: {"margin-bottom":"0","color":"var(--ch-black-80)","font-size":"var(--font-sm)","font-weight":"500","letter-spacing":"-4%"} }, " License of Practice ", -1)),
            (__props.staff?.licenseExpiry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "Expires ", -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(__props.staff.licenseExpiry as string) ?? '-'), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('view'))),
          href: (__props.staff.practitionerLicenseURL as string),
          target: "_blank",
          rel: "noopener noreferrer",
          class: "view-document ms-1",
          "data-testid": "view-staff-doc"
        }, " View ", 8, _hoisted_6)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_7, "N/A"))
}
}

})